export interface GlobalSiteHeaderProps {
  location: Location;
}

export enum MemberStatus {
  Anonymous,
  NonMember,
  Member,
}
